// import { useEffect } from "react";
// import { useSelector } from "react-redux";
import CreatableSelect from 'react-select/creatable';

const FiltroCompetencia = ({ handleChangeCompetencia, competencias }: iProps) => {
    // const notasServicoCompetencia:string[] = useSelector((state:any) => state.uiNotasServico.competencias)

    // const startYear = 2025;
    // const startMonth = 8; // Agosto (1–12)

    const generateMonths = () => {
        const months = [];
        const now = new Date();

        // Mês atual +1
        const end = new Date(now.getFullYear(), now.getMonth() + 1);

        // const current = new Date(startYear, startMonth - 1);
        const current = new Date(now.getFullYear(), now.getMonth() - 3);

        while (current <= end) {
            const year = current.getFullYear();
            const month = String(current.getMonth() + 1).padStart(2, "0");
            const valueCurrent = `${month}/${year}`// MM/YYYY
            months.push({
                value: valueCurrent,
                label: valueCurrent,
            });
            current.setMonth(current.getMonth() + 1);
        }
        months.push({
            value: "",
            label: "Todos"
        });
        let monthsAux = []
        for (let i = months.length - 1; i >= 0; i--) {
            monthsAux.push(months[i])
        }
        return monthsAux;
    };

    const months: any = generateMonths();

    // Valor padrão: mês atual no formato YYYY-MM
    // const defaultValue = (() => {
    //     const now = new Date();
    //     const y = now.getFullYear();
    //     const m = String(now.getMonth() + 1).padStart(2, "0");
    //     return `${m}/${y}`;
    // })();
    // const defaultValueChoice = (():any => {
    //     const primeiroLoading = notasServicoCompetencia.search("#") > 0 ? false : true
    //     if (!primeiroLoading) {
    //         const notasServicoCompetenciaAux = notasServicoCompetencia.replaceAll("#", "")
    //         const y = notasServicoCompetenciaAux.split("/")[1]
    //         const m = notasServicoCompetenciaAux.split("/")[0]
    //         return [{
    //             "value": `${m}/${y}`,
    //             "label": `${m}/${y}`,
    //         }];
    //     }
    //     const now = new Date();
    //     const y = now.getFullYear();
    //     const m = String(now.getMonth() + 1).padStart(2, "0");
    //     return [{
    //         "value": `${m}/${y}`,
    //         "label": `${m}/${y}`,
    //     }];
    // })();

    return (
        <div style={{width: "16%"}}>
        {/* <Form.Select name="competencia" id="competencia" defaultValue={defaultValue} style={{ width: "150px" }} onChange={(event) => { handleChangeCompetencia(event.target.value) }} >
            {months.map(({ value, label }:any) => (
                <option key={value} value={value}>
                    {label}
                </option>
            ))}
        </Form.Select> */}
        <CreatableSelect id="competencia" name="competencia" placeholder="Competência" isMulti options={months} onChange={(choice) => { handleChangeCompetencia(choice) }} value={competencias} />
        </div>
    );
};
interface iProps {
    handleChangeCompetencia: any
    competencias: any[]
}

export default FiltroCompetencia;
